export const theme = {
  modalBackground: Styles.color.white,
  disclaimerColor: Styles.color.grey.one,
};
